import orders from "./orders";
import purchases from "./purchases";

export default {
	orders,
	purchases
};
